// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notice-detail {
  width: 100%;
  min-height: 400px;
}

.notice-detail.empty {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6c757d;
  font-size: 16px;
}

.detail-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding-bottom: 20px;
  border-bottom: 2px solid #e9ecef;
  margin-bottom: 20px;
}

.detail-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}

.meta-item {
  font-size: 14px;
  color: #6c757d;
  background-color: #f8f9fa;
  padding: 6px 12px;
  border-radius: 20px;
}

.print-button {
  padding: 10px 20px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
}

.print-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(102, 126, 234, 0.4);
}

.detail-content {
  line-height: 1.8;
  color: #495057;
}

.detail-content h1 {
  font-size: 28px;
  margin: 20px 0 15px;
  color: #2c3e50;
}

.detail-content h2 {
  font-size: 24px;
  margin: 18px 0 12px;
  color: #2c3e50;
}

.detail-content h3 {
  font-size: 20px;
  margin: 16px 0 10px;
  color: #495057;
}

.detail-content h4 {
  font-size: 18px;
  margin: 14px 0 8px;
  color: #495057;
}

.detail-content p {
  margin: 10px 0;
  line-height: 1.6;
}

.detail-content ul,
.detail-content ol {
  margin: 10px 0;
  padding-left: 30px;
}

.detail-content li {
  margin: 6px 0;
  line-height: 1.6;
}

.detail-content hr {
  border: none;
  border-top: 1px solid #e9ecef;
  margin: 20px 0;
}

.detail-content strong {
  font-weight: 600;
  color: #2c3e50;
}

@media (max-width: 768px) {
  .detail-header {
    flex-direction: column;
    gap: 15px;
  }
  
  .detail-meta {
    width: 100%;
  }
  
  .print-button {
    width: 100%;
  }
  
  .detail-content h1 {
    font-size: 24px;
  }
  
  .detail-content h2 {
    font-size: 20px;
  }
  
  .detail-content h3 {
    font-size: 18px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/NoticeDetail.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,oBAAoB;EACpB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".notice-detail {\n  width: 100%;\n  min-height: 400px;\n}\n\n.notice-detail.empty {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #6c757d;\n  font-size: 16px;\n}\n\n.detail-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  padding-bottom: 20px;\n  border-bottom: 2px solid #e9ecef;\n  margin-bottom: 20px;\n}\n\n.detail-meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 15px;\n}\n\n.meta-item {\n  font-size: 14px;\n  color: #6c757d;\n  background-color: #f8f9fa;\n  padding: 6px 12px;\n  border-radius: 20px;\n}\n\n.print-button {\n  padding: 10px 20px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  white-space: nowrap;\n}\n\n.print-button:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(102, 126, 234, 0.4);\n}\n\n.detail-content {\n  line-height: 1.8;\n  color: #495057;\n}\n\n.detail-content h1 {\n  font-size: 28px;\n  margin: 20px 0 15px;\n  color: #2c3e50;\n}\n\n.detail-content h2 {\n  font-size: 24px;\n  margin: 18px 0 12px;\n  color: #2c3e50;\n}\n\n.detail-content h3 {\n  font-size: 20px;\n  margin: 16px 0 10px;\n  color: #495057;\n}\n\n.detail-content h4 {\n  font-size: 18px;\n  margin: 14px 0 8px;\n  color: #495057;\n}\n\n.detail-content p {\n  margin: 10px 0;\n  line-height: 1.6;\n}\n\n.detail-content ul,\n.detail-content ol {\n  margin: 10px 0;\n  padding-left: 30px;\n}\n\n.detail-content li {\n  margin: 6px 0;\n  line-height: 1.6;\n}\n\n.detail-content hr {\n  border: none;\n  border-top: 1px solid #e9ecef;\n  margin: 20px 0;\n}\n\n.detail-content strong {\n  font-weight: 600;\n  color: #2c3e50;\n}\n\n@media (max-width: 768px) {\n  .detail-header {\n    flex-direction: column;\n    gap: 15px;\n  }\n  \n  .detail-meta {\n    width: 100%;\n  }\n  \n  .print-button {\n    width: 100%;\n  }\n  \n  .detail-content h1 {\n    font-size: 24px;\n  }\n  \n  .detail-content h2 {\n    font-size: 20px;\n  }\n  \n  .detail-content h3 {\n    font-size: 18px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
